import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getDepartments = () => async (dispatch) => {
    dispatch({
        type: 'ODOO_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/odoo/getDepartments', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DEPARTMENTS_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ODOO_NOT_LOADING'
        })
    }
}

export const sendTicket = (formData) => async (dispatch) => {
    dispatch({
        type: 'ODOO_LOADING'
    })

    try {
        const { data, status } = await Axios.post(
            '/api/odoo/createTicket',
            formData,
            {
                headers: {
                    auth: localStorage.getItem('jwt'),
                    'Content-Type': 'multipart/form-data'
                }
            }
        )

        if (status === 200) {
            dispatch({
                type: 'TICKET_SEND_SUCCESS',
                payload: data
            })
        }

    } catch (error) {
        dispatch({
            type: 'ODOO_NOT_LOADING'
        })
    }
}

export const getMyTickets = (
        page = 1,
        pageSize = 25,
        statusTicket = 'abiertos',
        search = '',
        sortField = 'create_date',
        sortOrder = 'desc'
    ) => async (dispatch) => {
    dispatch({
        type: 'ODOO_TICKETS_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/odoo/getMyTickets',
            {page, pageSize, statusTicket, search, sortField, sortOrder}, {
            headers: { auth: localStorage.getItem('jwt') },
        })
        dispatch({
            type: 'ODOO_TICKETS_SUCCESS',
            payload: data
        })

    } catch (error) {
        dispatch({
            type: 'ODOO_TICKETS_ERROR'
        })
        console.error(error);
    }
}

export const replyTicket = (form) => async (dispatch) => {
    dispatch({
        type: 'ODOO_LOADING'
    })

    try {
        const { data, status } = await Axios.post('/api/odoo/replyTicket', form,
            { headers: { auth: localStorage.getItem('jwt') } }
        )

        if (status === 200) {
            dispatch({
                type: 'REPLY_TICKET_SUCCESS'
            })
        }

    } catch (error) {
        dispatch({
            type: 'ODOO_NOT_LOADING'
        })
    }
}

export const getTicketMessages = (ticket_id) => async (dispatch) => {
    try {
        const { data } = await Axios.post('/api/odoo/getTicketMessages/' + ticket_id, {},
            { headers: { auth: localStorage.getItem('jwt') } }
        )

        dispatch({
            type: 'TICKET_MESSAGES_SUCCESS',
            payload: data.messages
        })

    } catch (error) {
        console.error(error)
    }
}